var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input_video"},[_c('video-player',{ref:"videoPlayer",staticClass:"video-player vjs-custom-skin",attrs:{"playsinline":true,"options":_vm.playerOptions},on:{"play":function($event){return _vm.onPlayerPlay($event)},"pause":function($event){return _vm.onPlayerPause($event)},"ready":_vm.playerReadied}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }